export let getLiterals: () => Promise<any>;

if (process.env.VITE_APP_NAME === 'Vottun Dojo') {
	getLiterals = () =>
		import('./vottun/literals.ts').then((module) => module.literals);
} else if (process.env.VITE_APP_NAME === 'Battle Derby') {
	getLiterals = () =>
		import('./battle-derby/literals.ts').then((module) => module.literals);
} else {
	throw new Error(`No libraries for ${process.env.VITE_APP_NAME}`);
}
